import ProjectContentComponent from "./ProjectContentComponent";

export default ProjectContentComponent;
